import StatementRegenerateDialog from './StatementRegenerateDialog';

export default StatementRegenerateDialog;
